import type { BroadcastEnv } from "src/types/broadcasts";
import { getBroadcastEnvInfo } from "./notificationRoutes";

/**
 * The single environment this build targets. Each Firebase Hosting site is a
 * separate per-env deployment (ivueit = prod, ivueit-sandbox, ivueit-staging,
 * ivueit-preprod, ivueit-beta), so the environment is fixed at build time via
 * `REACT_APP_ENV` rather than chosen in the UI.
 *
 * The environment matters only for the secondary (iv3api) auth + the API calls
 * that use its token — everything else (Google auth, Firestore, roles) is the
 * same across sites.
 */
const VALID_ENVS: readonly BroadcastEnv[] = [
  "local",
  "sandbox",
  "staging",
  "preprod",
  "prod",
];

const raw = (process.env.REACT_APP_ENV || "prod").trim().toLowerCase();

export const APP_ENV: BroadcastEnv = (VALID_ENVS as readonly string[]).includes(
  raw,
)
  ? (raw as BroadcastEnv)
  : "prod";

/** iv3api base URL for this build's environment. */
export const APP_ENV_BASE_URL: string = getBroadcastEnvInfo(APP_ENV).baseUrl;

export const IS_PROD_ENV = APP_ENV === "prod";
